import React from 'react';

export const ErrorMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className="alert alert-danger drilldown-error">
    <span className="glyphicon glyphicon-exclamation-sign" /> {message}
  </div>
);
